import React from "react";
import { Landmark, CalendarDays, Users, FileText, Hash } from "lucide-react";
import { Sekcja, RowIcon, mono } from "./atoms";

export default function DaneKRSSection({ krs }) {
  const court = krs?.court || {};
  return (
    <Sekcja
      title="Dane KRS"
      icon={Landmark}
      titleStyle={{ fontSize: 20, color: "#0b74e5", textDecorationThickness: "2px", textUnderlineOffset: 4 }}
    >
      <div className="sectionGrid">
        <div>
          <RowIcon icon={CalendarDays} label="Data utworzenia">{krs?.created_at || <em>—</em>}</RowIcon>
          <RowIcon icon={CalendarDays} label="Data rejestracji">{krs?.registration_date || <em>—</em>}</RowIcon>
          <RowIcon icon={CalendarDays} label="Data ostatniej zmiany">{krs?.last_registry_update || <em>—</em>}</RowIcon>
        </div>
        <div>
          <RowIcon icon={Users} label="Reprezentowane przez">{krs?.representation_body || <em>—</em>}</RowIcon>
          <RowIcon icon={Landmark} label="Sąd">{court?.name || <em>—</em>}</RowIcon>
          <RowIcon icon={Hash} label="Identyfikator">{mono(court?.ident)}</RowIcon>
        </div>
        <div className="fullRow">
          <RowIcon icon={FileText} label="Reprezentacja">
            <span className="preWrap">{krs?.representation || <em>—</em>}</span>
          </RowIcon>
        </div>
      </div>
    </Sekcja>
  );
}
